import BeliefsList from './BeliefsList'

export default BeliefsList
